module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Total Balance")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.totalBal(_vm.message).toFixed(2)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-sm-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Bank Balance")]), _vm._v(" "), (_vm.message.length > 0) ? _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(((_vm.message[4].bank[0][0].totalBankDr + parseFloat(_vm.message[4].bank[2][0].totalBankOpeningBalance)) - _vm.message[4].bank[1][0].totalBankCr).toFixed(2)))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Cash Balance")]), _vm._v(" "), (_vm.message[3]) ? _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(((_vm.message[3].cash[0][0].totalCashDr + parseFloat(_vm.message[3].cash[2][0].totalCashOpeningBalance)) - _vm.message[3].cash[1][0].totalCashCr).toFixed(2)))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("SMS Balance")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.smsbal))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon box-green"
  }, [_c('i', {
    staticClass: "ion ion-cash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon box-red"
  }, [_c('i', {
    staticClass: "fa fa-university"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon box-blue"
  }, [_c('i', {
    staticClass: "fa fa-inr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon box-yellow"
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-62720ec8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dashboard/balancerecord.vue
// module id = 771
// module chunks = 0